// extracted by mini-css-extract-plugin
export default {"container":"design_container__+TMOR","row":"design_row__oLVzA","image":"design_image__QgAq2"};